import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class OutageScheduleReportAPI {
  static getScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetOutageScheduleReportData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }
  static SaveUserFacilityMappingData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveUserFacilityMappingData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }
  static getOutageLoggedInUserProfile(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetOutageLoggedInUserInfo,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }
  static saveUserData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveOutageUserData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static updateUserData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveOutageUserData,
      'PUT',
      AppConstants.APP_BACKEND_HOST_KEY, //undo this and use method callAzureFunction while checking in
      data
    );
  }
  static getEditRowData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetOutageScheduleEditData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }
  static getCommentsData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetOutageCommentsData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }

  static saveScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveOutageScheduleReportData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static updateData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveOutageScheduleReportData,
      'PUT',
      AppConstants.APP_BACKEND_HOST_KEY, //undo this and use method callAzureFunction while checking in
      data
    );
  }
  static deleteData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveOutageScheduleReportData,
      'DELETE',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
